import { baseUrl } from "../index";
import axios from "axios";

export const CentralCall = async payload => {
    return await axios.post(`${baseUrl}central/centralcall`, payload, { Headers: { "Content-Type": "application/json" } });
}